module.exports = __webpack_public_path__ + "img/houseEnergyUsed.728f1ab9.svg";